import { render, staticRenderFns } from "./SimpleErrorMessage.vue?vue&type=template&id=323b3dec&scoped=true"
import script from "./SimpleErrorMessage.vue?vue&type=script&lang=js"
export * from "./SimpleErrorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323b3dec",
  null
  
)

export default component.exports